import React from 'react';
import './Coverphoto.css';
function Coverphoto() {
	return (
		<div className="coverphoto">
			{/*  */}
			{/* <div></div> */}
			<img
				src="https://napawear.com/images/promo/2663/NAPA-November-2020-Promo_Banner.jpg?t=1604366402"
				alt="coverphoto"
			/>
		</div>
	);
}

export default Coverphoto;
